import { GridColDef } from "@mui/x-data-grid";
import { IconButton } from "@mui/material"; // Ou sua importação específica
import ItemStatus from "../../../../../../common/components/item_status";
import dataUtils from "../../../../../../common/utils/dataUtils";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import LargeItemStatus from "../../../../../../common/components/large_item_status";

type AllowedColors = "green" | "red" | "blue" | "yellow" | "gray";

interface StatusProps {
  title: string;
  color: AllowedColors;
  description: string;
}

interface Props {
  onActionEditar: (id: number, open: boolean) => void;
}

export const GenerateAvaliacaoColumns = ({
  onActionEditar
}: Props): GridColDef[] => {


  const getStatusProps = (status: boolean): StatusProps => {
    switch (status) {
      case false: // EM ELABORACAO
        return { title: "P", color: "gray", description: "Avaliação do Fornecimento pendente" };
      case true: // APROVADAS
        return { title: "A", color: "green", description: "Fornecimento Avaliado" };
      default:
        return { title: "P", color: "gray", description: "Desconhecido" };
    }
  };


  const getNotaProps = (nota: boolean): StatusProps => {
    if (nota) {
      return { title: "Sim", color: "green", description: "Sim" };
    } else {
      return { title: "Não", color: "gray", description: "Não" };
    }
  };


  return [
    {
      field: "FornecedorAvaliado",
      headerName: "Status",
      width: 80, 
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        const { title, color, description } = getStatusProps(params.value);
        return (
          <div className="w-full h-full flex justify-center items-center">
            <ItemStatus title={title} color={color} description={description} />
          </div>
        );
      }
    },
    {
      field: "NotaFiscalEntregue", 
      headerName: "NF Entregue",
      width: 110, 
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        const { title, color, description } = getNotaProps(params.value);
        return (
          <div className="w-full h-full flex justify-center items-center">
            <LargeItemStatus title={title} color={color} description={description} /> 
          </div>
        );
      }
    },
    {
      field: "NrMedicaoTerceirizacao",
      headerName: "Nº",
      width: 60, 
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        return (<div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "NumeroContrato",
      headerName: "Contrato",
      width: 100, 
      renderCell: (params) => {
        return (<div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "NomeFornecedor",
      headerName: "Fornecedor",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "NomeCentroCusto",
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "NomeAvaliador",
      headerName: "Responsável pela Avaliação",
      flex: 1,
      minWidth: 190,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "DataAvaliacao",
      headerName: "Data Avaliação",
      width: 130,
      renderCell: (params) => { 
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <span>{dataUtils.dataFormatada(params.value ? params.value : null)}</span>
          </div>
        );
      },
    },
    {
      field: 'IdMedicaoTerceirizacao',
      headerName: 'Ações',
      sortable: false,
      filterable: false,
      width: 80, 
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.value, true)} title="Editar">
            <DynamicIcon nameIcon="EditRounded" size={20} className="text-blue-500" />
          </IconButton>
        </div>
      ),
    },
  ];
}